const firebaseConfig = {
    apiKey: "AIzaSyA8BTv-w-Gb5C4sZYoR7cvaORV4FhJCCcw",
    authDomain: "travel-site-m696.firebaseapp.com",
    databaseURL: "https://travel-site-m696.firebaseio.com",
    projectId: "travel-site-m696",
    storageBucket: "travel-site-m696.appspot.com",
    messagingSenderId: "118104575403",
    appId: "1:118104575403:web:b48779626d935a767396ee"
  };
  export default firebaseConfig;